import ExpandMore from "@mui/icons-material/ExpandMore";
import {
  Collapse,
  IconButton,
  List,
  ListItemButton,
  ListSubheader,
  Typography,
} from "@mui/material";
import type React from "react";
import { useState } from "react";
import type { Item } from "./HelpConstant";

interface HelpCardData {
  helpId: string;
  title: string;
  sections: Item[];
  targetItem: Item | undefined;
  isInternal?: boolean;
  setSearchParams: (params: any) => void;
}

export const HelpCard = ({
  helpId,
  title,
  sections,
  targetItem,
  setSearchParams,
}: HelpCardData) => {
  const [open, setOpen] = useState<boolean>(true);
  const handleExpandContent = (
    // biome-ignore lint/correctness/noUnusedFunctionParameters: ToBeEvaluated with the team
    e: React.MouseEvent<HTMLButtonElement>,
    // biome-ignore lint/correctness/noUnusedFunctionParameters: ToBeEvaluated with the team
    helpId: string,
  ) => {
    setOpen(!open);
  };
  return (
    <List
      sx={{
        width: "100%",
        maxWidth: "312px",
        backgroundColor: "#fff",
        marginBottom: "16px",
      }}
      component="nav"
      aria-labelledby="nested-list-subheader"
      subheader={
        <ListSubheader
          component="div"
          id="nested-list-subheader"
          sx={{
            color: "#000",
            fontFamily: 'var(--font-family, "AktivGrotesk")',
            fontWeight: 500,
            position: "relative",
            height: "48px",
            lineHeight: "16px",
            paddingTop: "16px",
          }}
        >
          {title}
          <IconButton
            sx={{
              "&:hover": { backgroundColor: "inherit" },
              top: "5px",
              position: "absolute",
              right: "16px",
            }}
            aria-label={"Search"}
            onClick={(e) => handleExpandContent(e, helpId)}
            edge="end"
            key={helpId}
          >
            <ExpandMore sx={{ color: "#000" }} />
          </IconButton>
        </ListSubheader>
      }
    >
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List
          component="div"
          disablePadding
          sx={{
            padding: "16px",
            "> .MuiButtonBase-root": {
              "&:hover": { backgroundColor: "#D9F1FB", borderColor: "#009FE4" },
            },
          }}
        >
          {sections.map((item) => {
            return (
              <ListItemButton
                onClick={() => {
                  setSearchParams({ section: helpId, category: item.id });
                }}
                key={item.id}
                sx={{
                  backgroundColor: `${item.id === targetItem?.id ? "#D9F1FB" : "#fff"}`,
                  borderColor: `${item.id === targetItem?.id ? "#009FE4" : "#E6E6E6"}`,
                  padding: "16px 12px",
                  border: "1px solid #E6E6E6",
                  marginBottom: "8px",
                }}
              >
                <Typography sx={{ lineHeight: 1 }}>
                  {item?.displayName}
                </Typography>
              </ListItemButton>
            );
          })}
        </List>
      </Collapse>
    </List>
  );
};
